export default[
    {
        path: 'productListProvider',
        name: {list:['产业服务','商品','商品管理','商品列表']},
        component: () => import('@/views/industryProvider/productList.vue')
    },
    {
        path: "productDetailsProvider",
        name: "产业服务商品详情预览",
        component: () => import("@/views/industryProvider/productDetails.vue"),
    },
    {
        path: 'categoryProvider',
        name: {list:['产业服务','商品','分类管理','分类管理']},
        component: () => import('@/views/industryProvider/category.vue')
    },
    {
        path: 'orderlistProvider',
        name: {list:['产业服务','订单','服务单管理','服务单列表']},
        component: () => import('@/views/industryProvider/orderList.vue')
    },
    {
        path: 'orderDetailsProvider',
        name: {list:['产业服务','订单','服务单管理','服务单列表','服务单详情'],title:'服务单详情'},
        component: () => import('@/views/industryProvider/orderDetails.vue')
    }   
]